import _ from 'lodash'

import app from '../app.jsx'

class ProfilerUtil {
  constructor (pageIdent, averageTime) {
    this._pageIdent = pageIdent
    this._averageTime = averageTime || 0
    this._noItems = 0
    this._param1 = ''
    this._param2 = ''
    this._param3 = ''
    this._list = []
  }

  setParams (param1, param2, param3) {
    this._param1 = param1 || null
    this._param2 = param2 || null
    this._param3 = param3 || null
  }

  start () {
    const id = ++this._noItems
    this._list.push({
      id: id,
      startDate: new Date(),
      endDate: null,
      startMemory: 0,
      endMemory: 0
    })

    return id
  }

  stop (id) {
    const profile = _.find(this._list, (obj) => obj.id === id)
    if (profile) {
      profile.endDate = new Date()
      profile.endMemory = 0

      let timeTaken =
        (profile.endDate.getTime() - profile.startDate.getTime()) / 1000
      timeTaken = parseFloat(timeTaken.toFixed(2))

      if (timeTaken > this._averageTime) {
        const pageInfo = app.getPageInfo(this._pageIdent)
        let url = pageInfo ? pageInfo.url : ''
        if (this._param1) {
          url = url.replace(/:param1/, this._param1)
        }

        if (this._param2) {
          url = url.replace(/:param2/, this._param2)
        }

        if (this._param3) {
          url = url.replace(/:param3/, this._param3)
        }

        url = app.getAppUrl(url)

        const profileData = {
          category: 'UI',
          teamId: app.getTeamId(),
          userId: app.loggedInId,
          path: url,
          timeTaken: timeTaken || 0,
          browser: navigator.userAgent,
          error: ''
        }

        this._saveProfile(profileData)
      }

      // Remove profiler log from list
      _.remove(this._list, (obj) => obj.id === id)
    }
  }

  /* Private function */
  _saveProfile (profileData) {
    // Call the creation in background
    app
      .service('/api/console/profiler')
      .create(profileData, {})
      .then((_res) => {})
      .catch((createErr) => {
        app.error(
          `Profiler::_saveProfile - Error in saving profiler ${createErr.message}`
        )
      })
  }
}

export default ProfilerUtil
